import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_chennai-finrun/artifacts/eabq3wxl_FINRUN%20LOGO%20PNG%202.png";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (!isHomePage) {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMobileMenuOpen(false);
  };

  const navItems = [
  { label: "Upcoming", action: () => scrollToSection("events") },
  { label: "Register", action: () => scrollToSection("pricing") },
  { label: "About", action: () => scrollToSection("about") },
  { label: "Past Events", action: () => scrollToSection("past-events") },
  { label: "Contact", action: () => scrollToSection("contact") }];


  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ?
      "bg-white/95 backdrop-blur-xl shadow-lg py-2" :
      "bg-black/30 backdrop-blur-sm py-3"}`
      }
      data-testid="navbar">

      <div className="container-custom">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <img
              src={LOGO_URL}
              alt="The FinRun - Stride Against Cyber Crimes"
              className="h-24 md:h-32 w-auto" />

          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) =>
            <button
              key={item.label}
              onClick={item.action}
              className={`text-sm font-medium transition-colors hover:text-[#FF3B30] ${
              isScrolled ? "text-[#4B5563]" : "text-white/80"}`
              }
              data-testid={`nav-${item.label.toLowerCase()}`}>

                {item.label}
              </button>
            )}
            <Link to="/sponsor">
              <Button
                variant="outline"
                className={`rounded-full px-6 ${
                isScrolled ?
                "border-[#007AFF] text-[#007AFF] hover:bg-[#007AFF] hover:text-white" :
                "border-white text-white hover:bg-white hover:text-[#0A0A0A]"}`
                }
                data-testid="nav-sponsor-btn">

                Become a Sponsor
              </Button>
            </Link>
            <Link to="/register">
              <Button
                className="btn-primary rounded-full px-6"
                data-testid="nav-register-btn">

                Register
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle">

            {isMobileMenuOpen ?
            <X className={`w-6 h-6 ${isScrolled ? "text-[#0A0A0A]" : "text-white"}`} /> :

            <Menu className={`w-6 h-6 ${isScrolled ? "text-[#0A0A0A]" : "text-white"}`} />
            }
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen &&
        <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-xl border-t">
            <div className="container-custom py-4 space-y-4">
              {navItems.map((item) =>
            <button
              key={item.label}
              onClick={item.action}
              className="block w-full text-left text-[#4B5563] hover:text-[#FF3B30] py-2">

                  {item.label}
                </button>
            )}
              <Link to="/sponsor" className="block">
                <Button
                variant="outline"
                className="w-full rounded-full border-[#007AFF] text-[#007AFF]">

                  Become a Sponsor
                </Button>
              </Link>
              <Link to="/register" className="block">
                <Button className="w-full btn-primary rounded-full">
                  Register Now
                </Button>
              </Link>
            </div>
          </div>
        }
      </div>
    </nav>);

};

export default Navbar;